//ボトムメニュー
OH.BottomNavi = (function (element) {
	//コンストラクタ
	var BottomNavi = function (element) {
		if(!(this instanceof BottomNavi)) return new BottomNavi(element);
		this.elem = element;
		this.onClassName = '';
		this.timer = 0;
		this.delayTime = 0;
	};
	//プロトタイプ
	var p = BottomNavi.prototype;
	p.activate = function (_self, flg) {
		return function () {
			flg ? _self.elem.classList.add(_self.onClassName) : _self.elem.classList.remove(_self.onClassName);
		};
	};
	p.init = function (option) {
		var displayControll = function (_self) {
			return function () {
				_self.activate(_self, false)();
				window.clearTimeout(_self.timer);
				_self.timer = window.setTimeout(_self.activate(_self, true), _self.delayTime);
			};
		};
		this.onClassName = option.onClassName;
		this.delayTime = option.delayTime;
		window.addEventListener('scroll', displayControll(this));
		window.addEventListener('touchmove', displayControll(this));
		return this;
	};
	return BottomNavi;
}());

OH.initBottomNavi = function (settings) {
	//iPhoneX対応
	var addViewportfit = function (target) {
		target.setAttribute('content', target.getAttribute('content') + ',viewport-fit=cover');
	};
	var init = function (options) {
		return function (element) {
			new OH.BottomNavi(element).init(options);
		};
	};
	//iPhone判定
	if (/[ \(]iP/.test(window.navigator.userAgent)) addViewportfit(document.querySelector('[name="viewport"]'));
	[].forEach.call(document.getElementsByClassName(settings.elemClassName), init(settings.option));
};
